import React, { Component, Fragment } from 'react'
import { Button, TableRow, TableCell, MenuItem } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../utils/common'
import { hasAccess } from '../../utils/api'
import { adjustmentTypes } from '../../utils/constants'

import { EditableTextField, EditableSwitch, EditableSelect } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'

export default class AdjustmentItem extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  onChangeRegions = (regions) => {
    const regionIds =
      (regions &&
        regions.map((region) => {
          return region.value
        })) ||
      []
    this.props.onChange('regionIds', regionIds)
  }

  render() {
    const { data = {}, editMode } = this.props

    const permitted = hasAccess()
    return (
      <TableRow>
        <TableCell className="cell-wrap-word">
          <EditableSwitch
            valueToRender={data.active ? 'Active' : 'Inactive'}
            checked={data.active}
            editMode={editMode}
            onChange={this.onChange('active', true)}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.name}
            editMode={editMode}
            value={data.name}
            onChange={this.onChange('name')}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSelect
            value={data.type || ''}
            onChange={this.onChange('type')}
            valueToRender={data.type || ''}
            editMode={editMode}
            displayEmpty
          >
            <MenuItem value="">Select Adjustment Type</MenuItem>
            {adjustmentTypes.map((item, index) => {
              return (
                <MenuItem key={index} value={item.value}>
                  {item.label}
                </MenuItem>
              )
            })}
          </EditableSelect>
        </TableCell>
        <TableCell className="cell-wrap-word">
          {permitted ? (
            <Fragment>
              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.onCancel}
                onEdit={this.props.enableEdit}
                editMode={editMode}
              />
              {!editMode ? (
                <Button className="danger-button margin" onClick={this.props.onDelete}>
                  Delete
                </Button>
              ) : null}
            </Fragment>
          ) : (
            <Fragment></Fragment>
          )}
        </TableCell>
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Adjustments/AdjustmentItem.js